import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowCircleLeftIcon } from '@heroicons/react/outline';
import classNames from 'classnames';

type BackProps = {
  className?: string;
  returnLocation?: string;
};

export const Back = ({ className, returnLocation }: BackProps) => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (returnLocation) {
      return navigate(returnLocation);
    }
    navigate(-1);
  };

  return (
    <button
      type="button"
      aria-label="Back"
      className={classNames(
        'cursor-pointer w-auto rounded focus:outline-none focus:ring-2 focus:ring-blue-600',
        className,
      )}
      onClick={handleGoBack}
    >
      <ArrowCircleLeftIcon className="h-8 w-8" />
    </button>
  );
};
